import React, { useState, useEffect } from 'react';
import { Icon } from '@iconify/react/dist/iconify.js';
import ModalAlert from '../../components/ModalAlert';
import PostByAgg from '../../utils/axios';
import LottieLoading from '../../components/child/LottieLoading';
import Select from 'react-select';

const CreateBAForm = ({ open, mode, upload, handleClose , refreshData}) => {
    const [formData, setFormData] = useState({
        document_no : "",
        music_label_code : "",
        document_type_code : "", 
        subject : "",
        description : "",
        period_start : "",
        period_end : "",
        issued_date : "",
        created_by : "admin"
    });
    const [modal, setModal] = useState(<div></div>);
    const [isLoading, setIsLoading] = useState(false);

    // state list label
    const [listLabel, setListLabel] = useState([]);
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 10,
        totalRecords: 0,
        totalPages: 0,
    });


   useEffect(() => {
  if (open && mode === "create") {
    setFormData({
      document_no: "",
      music_label_code: "",
      document_type_code: "",
      subject: "",
      description: "",
      period_start: "",
      period_end: "",
      issued_date: "",
      created_by: "admin",
    });
  }

  if (open && mode !== "create" && upload) {
    // kalau mode view / update isi form dengan data upload
    setFormData(upload);
  }
}, [open, mode, upload]);

    // === GET LIST LABEL ===
    const GetListLabel = () => {
        setIsLoading(true);
        const url = 'label/lm/v1/music-label/list';
        PostByAgg({
            url: url,
            body: {
                page: pagination.pageIndex + 1,
                page_size: pagination.pageSize,
            },
            onResponse: onResponseListLabel,
            onError: onErrorListLabel
        })
    }

    const onResponseListLabel = (response) => {
        console.log("Response List Label: ", response.data.data)
        if (response.data.code === '2002000' && response.data.data) {
            const totalRecords = response.data.data.total_records;
            const totalPages = Math.ceil(totalRecords / pagination.pageSize);
            setPagination((prev) => ({
                ...prev,
                totalRecords: totalRecords,
                totalPages: totalPages,
                pageSize: totalRecords,
            }));
            setListLabel(response.data.data.data);
        } else {
            setListLabel([]);
        }
        setIsLoading(false);
    }

    const onErrorListLabel = (error) => {
        console.log("Error List Label: ", error);
        setIsLoading(false);
        if(error.response){
            setModal(
                <ModalAlert
                    show={true}
                    text={error.response.data}
                    type={"failed"}
                    action={() => {}}
                />
            )
        }
    }

    useEffect(() => {  
        GetListLabel();
    }, []);


    // map listLabel ke react-select options
    const musicLabelOptions = listLabel.map((item) => ({
        value: item.music_label_code,
        label: item.music_label_name
    }));

    // opsi document_type_code fix
    const documentTypeOptions = [
        { value: "DT2508311907636", label: "Berita Acara" },
        { value: "DT2508317405122", label: "Agreement" }
    ];


    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);

        const url = "label/lm/v1/document/create";

        const body = {
            document_no: formData.document_no,
            music_label_code: formData.music_label_code,
            document_type_code: formData.document_type_code,
            subject: formData.subject,
            description: formData.description,
            period_start: formData.period_start,
            period_end: formData.period_end,
            issued_date: formData.issued_date,
            created_by: formData.created_by || "admin",
        };

        PostByAgg({
            url,
            body,
            onResponse: onResponseCreate,
            onError: onResponseErrorCreate,
        });

        function onResponseCreate(response) {
            console.log("Response from create:", response.data);
            setIsLoading(false);
            if (response.data.code === "2002000") {
            setModal(
                <ModalAlert
                show={true}
                type="success"
                text={response.data.message.id}
                action={() => {
                    setModal(<div></div>);
                    refreshData();
                    handleClose();
                }}
                />
            );
            }
        }

        function onResponseErrorCreate(error) {
            console.log("Error from create:", error.response.data);
            setIsLoading(false);
            if (error.response.data.code === "4003400") {
            setModal(
                <ModalAlert
                show={true}
                type="failed"
                text={error.response.data.message.id}
                action={() => handleClose()}
                />
            );
            }
        }
    };


    return (
        <div className={`modal fade ${open ? "show" : ""}`} tabIndex="-1" style={{ display: open ? "block" : "none" }} aria-hidden={!open}>
            <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content">
                    <div className="modal-header justify-content-between">
                        <h5 className="modal-title">
                            {mode === 'create' ? 'Create Document' : 
                             mode === 'view' ? 'View Document' : 
                             mode === 'update' ? 'Update Document' : 'Delete Document'}
                        </h5>
                        <button type="button" className="close" onClick={handleClose}>
                            <Icon icon="mdi:close-circle" width={24} height={24} />
                        </button>
                    </div>
                    <div className="modal-body">
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                {/* Document No */}
                                <div className="col-md-6 mb-3">
                                    <label className="col-form-label">Document No:</label>
                                    <input
                                        required
                                        type="text"
                                        className="form-control"
                                        value={formData.document_no}
                                        onChange={(e) => setFormData({ ...formData, document_no: e.target.value })}
                                        readOnly={mode === 'view'}
                                        disabled={mode === 'view'}
                                    />
                                </div>

                                {/* Music Label */}
                                <div className="col-md-6 mb-3">
                                    <label className="col-form-label">Music Label:</label>
                                    <Select
                                        value={musicLabelOptions.find(opt => opt.value === formData.music_label_code) || null}
                                        onChange={(selected) =>
                                            setFormData({
                                            ...formData,
                                            music_label_code: selected ? selected.value : "",
                                            })
                                        }
                                        options={musicLabelOptions}
                                        isClearable
                                        isSearchable
                                        isDisabled={mode === "view"}
                                        placeholder="select music label"
                                    />

                                </div>

                                {/* Document Type */}
                                <div className="col-md-6 mb-3">
                                    <label className="col-form-label">Document Type:</label>
                                    <Select
                                        value={documentTypeOptions.find(opt => opt.value === formData.document_type_code) || null}
                                        onChange={(selected) => setFormData({ ...formData, document_type_code: selected ? selected.value : "" })}
                                        options={documentTypeOptions}
                                        isClearable={false}
                                        isDisabled={mode === "view"}
                                        placeholder="Select Document Type"
                                    />
                                </div>

                                {/* Subject */}
                                <div className="col-md-6 mb-3">
                                    <label className="col-form-label">Subject:</label>
                                    <input
                                        required
                                        type="text"
                                        className="form-control"
                                        value={formData.subject}
                                        onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
                                        readOnly={mode === 'view'}
                                        disabled={mode === 'view'}
                                    />
                                </div>

                                {/* Description */}
                                <div className="col-md-12 mb-3">
                                    <label className="col-form-label">Description:</label>
                                    <textarea
                                        required
                                        className="form-control"
                                        value={formData.description}
                                        onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                                        readOnly={mode === 'view'}
                                        disabled={mode === 'view'}
                                    />
                                </div>

                                {/* Period Start */}
                                <div className="col-md-4 mb-3">
                                    <label className="col-form-label">Period Start:</label>
                                    <input
                                        required
                                        type="date"
                                        className="form-control"
                                        value={formData.period_start}
                                        onChange={(e) => setFormData({ ...formData, period_start: e.target.value })}
                                        readOnly={mode === 'view'}
                                        disabled={mode === 'view'}
                                    />
                                </div>

                                {/* Period End */}
                                <div className="col-md-4 mb-3">
                                    <label className="col-form-label">Period End:</label>
                                    <input
                                        required
                                        type="date"
                                        className="form-control"
                                        value={formData.period_end}
                                        onChange={(e) => setFormData({ ...formData, period_end: e.target.value })}
                                        readOnly={mode === 'view'}
                                        disabled={mode === 'view'}
                                    />
                                </div>

                                {/* Issued Date */}
                                <div className="col-md-4 mb-3">
                                    <label className="col-form-label">Issued Date:</label>
                                    <input
                                        required
                                        type="date"
                                        className="form-control"
                                        value={formData.issued_date}
                                        onChange={(e) => setFormData({ ...formData, issued_date: e.target.value })}
                                        readOnly={mode === 'view'}
                                        disabled={mode === 'view'}
                                    />
                                </div>
                            </div>

                            <div className="d-flex justify-content-end gap-2 mt-3">
                                {mode === 'create' && <button type="submit" className="btn btn-primary">Create</button>}
                                {mode === 'update' && <button type="submit" className="btn btn-primary">Update</button>}
                                {mode === 'view' && <button type="button" className="btn btn-secondary" onClick={handleClose}>Close</button>}
                            </div>
                        </form>
                    </div>
                    {isLoading && <LottieLoading text='Processing...' />}
                    {modal}
                </div>
            </div>
        </div>
    );
};

export default CreateBAForm;
